// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__VHV5b","registration__logo":"Registration_registration__logo__u2Ig4","registration__title":"Registration_registration__title__YfhfC"};